<template>
	<div class="c-specialists__modal--body">
		<div class="c-specialists__modal--formintro">
			<span class="h3">{{ introTitle }}</span>
			<p>{{ getTranslation(introText) }}</p>
		</div>
		<form :id="'form_' + id" class="c-specialists__modal--form">
			<div class="c-specialists__modal--formgroup">
				<input id="name" v-model="form.name" type="text" placeholder=" " required />
				<label for="name">{{ formfieldName }}</label>
			</div>
			<div class="c-specialists__modal--formgroup">
				<input id="telephoneNumber" v-model="form.telephoneNumber" type="text" placeholder=" " required />
				<label for="telephoneNumber">{{ formfieldPhoneNumber }}</label>
			</div>
			<button type="submit" :class="['btn', 'btn-primary', 'btn-phone', 'btn-hasloader', { 'btn-loading': isSending }]" @click="submitForm">
				<i class="fal fa-phone"></i>
				<i class="fal fa-times"></i>
				<span>{{ formButtonText }}</span>
			</button>
		</form>
		<div v-if="formSend" class="c-specialists__modal--formsend">
			<div class="c-specialists__modal--formsend--inner">
				<div class="c-checkmark">
					<div class="c-checkmark__icon">
						<span class="c-checkmark__icon--line line-tip"></span>
						<span class="c-checkmark__icon--line line-long"></span>
						<div class="c-checkmark__icon--circle"></div>
						<div class="c-checkmark__icon--fix"></div>
					</div>
				</div>
				<span class="h3">{{ sendTitle }}</span>
				<p>{{ getTranslation(sendText) }}</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		firstName: {
			type: String,
			required: true
		},
		fullName: {
			type: String,
			required: true
		},
		mail: {
			type: String,
			required: true
		},
		mailContact: {
			type: String,
			required: true
		},
		formButtonText: {
			type: String,
			required: true
		},
		formfieldName: {
			type: String,
			required: true
		},
		formfieldPhoneNumber: {
			type: String,
			required: true
		},
		introTitle: {
			type: String,
			required: true
		},
		introText: {
			type: String,
			required: true
		},
		sendTitle: {
			type: String,
			required: true
		},
		sendText: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			id: null,
			form: {
				name: '',
				telephoneNumber: ''
			},
			isSending: false,
			formSend: false
		};
	},
	mounted() {
		this.id = this._uid;
	},
	methods: {
		getTranslation(key) {
			return key.replace('{0}', this.firstName);
		},
		submitForm(e) {
			this.isSending = true;
			e.preventDefault();

			const form = document.getElementById('form_' + this.id);
			const invalidFields = form.querySelectorAll(':invalid');

			if (form.checkValidity() === false && invalidFields.length > 0) {
				invalidFields[0].focus();
				this.isSending = false;

				const btn = e.target;
				btn.classList.add('shake');

				setTimeout(function () {
					btn.classList.remove('shake');
				}, 1000);
			} else {
				this.sendForm();
				this.sendDataLayerEvent();
			}
		},
		sendForm() {
			var formData = {
				specialistName: this.fullName,
				specialistMail: this.mailContact,
				name: this.form.name,
				telephoneNumber: this.form.telephoneNumber,
				dataConsent: true
			};
			const requestOptions = {
				method: 'POST',
				body: JSON.stringify(formData),
				headers: {
					'Content-Type': 'application/json'
				}
			};
			fetch('/Umbraco/Api/CallMeBackForm/SubmitForm', requestOptions)
				.then((response) => {
					if (response.ok) {
						this.formSend = true;
						this.isSending = false;
						this.form.name = '';
						this.form.telephoneNumber = '';
					} else {
						/* validation error; unknown Umbraco form, empty field, no data consent, etc. */
						this.isSending = false;
					}
				})
				.catch((error) => {
					console.log(error);
				});
		},
		sendDataLayerEvent() {
			window.dataLayer = window.dataLayer || [];
			const dataLayerEvent3 = {
				event: 'Contact specialist opgenomen',
				eventCategory: 'Contact specialist opgenomen',
				eventAction: 'Formulier',
				eventLabel: this.fullName
			};
			window.dataLayer.push(dataLayerEvent3);
		}
	}
};
</script>
